export interface AppAdministratorResourcesSupplementsListFormRemove {
  id: string;
  organization_id: string;
  content: {
    name: string;
    description: string;
  };
}

export class AppAdministratorResourcesSupplementsListFormRemove implements AppAdministratorResourcesSupplementsListFormRemove {
  id: string;
  organization_id: string;
  content: {
    name: string;
    description: string;
  };

  constructor() {
    this.id = "";
    this.organization_id = "";
    this.content = {
      name: "",
      description: "",
    };
  }
}